export const HERO_CONSTANTS = {
  TAG: "Pet Care",
  DATE: "October 23, 2023",
  TITLE: "Eco-Friendly and Effective: Tofu Cat Litter",
  DESCRIPTION:
    "Discover the benefits of using tofu cat litter for your feline friends. Learn about its eco-friendly properties, effectiveness, and how it compares to traditional cat litter options.",
  HERO_IMAGE:
    "https://images.pexels.com/photos/1234567/pexels-photo-1234567.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
};

export const ARTICLE_SUMMARY = [
  "Tofu cat litter is an eco-friendly and effective alternative to traditional cat litter. This guide explores the benefits of using tofu cat litter and how it compares to other options.",
  "From its biodegradable properties to its superior odor control, tofu cat litter offers a range of advantages for both cats and their owners. We'll delve into the different types of tofu cat litter available and how to use them effectively.",
  "Whether you're looking for a more sustainable option or simply want to improve your cat's litter experience, tofu cat litter provides a great solution. Let's explore the potential benefits and applications of tofu cat litter.",
];

export const ARTICLE_STEPS = [
  {
    title: "1. Understanding Tofu Cat Litter",
    content:
      "Tofu cat litter is made from natural soybean byproducts, making it biodegradable and eco-friendly. It offers excellent odor control and clumping properties, making it a convenient and effective choice for cat owners.",
  },
  {
    title: "2. Benefits of Using Tofu Cat Litter",
    content:
      "Tofu cat litter offers several benefits, including being environmentally friendly, having superior odor control, and being safe for cats. It is also lightweight and easy to handle, making it a convenient option for cat owners.",
  },
  {
    title: "3. Applications in Pet Care",
    content:
      "Tofu cat litter can be used in a variety of pet care applications, from everyday use to travel. Its biodegradable properties make it an excellent choice for environmentally conscious pet owners.",
  },
  {
    title: "4. Choosing the Right Tofu Cat Litter",
    content:
      "When selecting tofu cat litter, consider factors such as clumping ability, odor control, and dust levels. Look for products that are made from high-quality ingredients and are free from harmful chemicals.",
  },
  {
    title: "5. Tips for Using Tofu Cat Litter",
    content:
      "To get the best results from tofu cat litter, ensure that you use the recommended amount and clean the litter box regularly. Gradually introduce your cat to the new litter to help them adjust.",
  },
  {
    title: "6. Maintenance and Care",
    content:
      "Keep your cat's litter box clean and well-maintained to ensure their comfort and health. Regularly replace the litter and clean the box to prevent odors and maintain a hygienic environment.",
  },
];

export const RELATED_ARTICLES = [
  {
    image:
      "https://images.pexels.com/photos/1234568/pexels-photo-1234568.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    date: "October 20, 2023",
    title: "Top Eco-Friendly Pet Products for 2023",
    description:
      "Explore the latest eco-friendly pet products for 2023, from tofu cat litter to sustainable toys. Learn how to make environmentally conscious choices for your pets.",
  },
  {
    image:
      "https://images.pexels.com/photos/1234569/pexels-photo-1234569.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    date: "October 15, 2023",
    title: "How to Transition Your Cat to Tofu Cat Litter",
    description:
      "Discover practical tips for transitioning your cat to tofu cat litter. Follow our step-by-step guide to make the switch smoothly and effectively.",
  },
  {
    image:
      "https://images.pexels.com/photos/1234570/pexels-photo-1234570.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    date: "October 12, 2023",
    title: "Choosing the Right Cat Litter for Your Feline Friend",
    description:
      "Learn about the different types of cat litter available, from tofu to clay. Understand the benefits and applications of each type to make informed decisions.",
  },
];

export const FOOTER_CONSTANTS = {
  CTA_TITLE: "Switch to Eco-Friendly Tofu Cat Litter",
  CTA_BACKGROUND:
    "https://images.pexels.com/photos/1234571/pexels-photo-1234571.jpeg",
  EMAIL_PLACEHOLDER: "Enter your email address",
  BUTTON_TEXT: "Learn More",
  COPYRIGHT: " 2024 Pet Care Trends. All rights reserved",
};
